export const FETCH_PAYMENT_SERVICE_CHARGES = 'FETCH_PAYMENT_SERVICE_CHARGES'
export const FETCH_PAYMENT_SERVICE_CHARGES_REQUEST = `${FETCH_PAYMENT_SERVICE_CHARGES}_REQUEST`
export const FETCH_PAYMENT_SERVICE_CHARGES_SUCCESS = `${FETCH_PAYMENT_SERVICE_CHARGES}_SUCCESS`
export const FETCH_PAYMENT_SERVICE_CHARGES_FAILURE = `${FETCH_PAYMENT_SERVICE_CHARGES}_FAILURE`

export const fetchPaymentServiceCharges = () => {
  return {
    type: FETCH_PAYMENT_SERVICE_CHARGES_REQUEST,
  }
}
